import {CSSProperties, FC, PropsWithChildren} from "react";

interface Props extends PropsWithChildren {
    header?: boolean;
    width?: string;
    className?: string;
    style?: CSSProperties;
    colSpan?: number;
}

const CenteredColumn: FC<Props> = (props) => {
    const {header, className, width, style, colSpan, children} = props;

    if (header) {
        return (
            <th
                colSpan={colSpan}
                className={(className || "") + " text-center"}
                style={{width, backgroundColor: "antiquewhite", ...style}}
            >
                {children}
            </th>
        );
    }

    return (
        <td
            colSpan={colSpan}
            className={(className || "") + " text-center"}
            style={{width, ...style}}
        >
            {children}
        </td>
    );
}

export default CenteredColumn;
